import { IconWrapper } from './IconWrapper'
import { IIconProps } from './props'

export function TeamPayIconDark(props: IIconProps) {
  return (
    <IconWrapper {...props}>
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.49993 0C11.28 0 13.0201 0.527727 14.5001 1.51666C15.9802 2.50559 17.1337 3.91128 17.8149 5.55581C18.4961 7.20035 18.6743 9.01 18.3271 10.7558C17.9798 12.5017 17.1226 14.1053 15.864 15.364C14.6053 16.6226 13.0017 17.4798 11.2558 17.8271C9.51 18.1743 7.70035 17.9961 6.05581 17.3149C4.41128 16.6337 3.00573 15.4802 2.0168 14.0001C1.02786 12.5201 0.5 10.78 0.5 8.99993C0.5 6.61298 1.44821 4.32387 3.13604 2.63604C4.82387 0.94821 7.11298 0 9.49993 0ZM8.3205 2.96263H10.4838V5.75766H13.4857V7.92108H10.4838V10.09H13.4857V12.2478H10.4838V15.0428H8.3205V12.2478H5.52547V10.0844H8.3205V7.91549H5.52547V5.75207H8.3205V2.95703V2.96263Z"
          fill="#2ED3C5"
        />
      </svg>
    </IconWrapper>
  )
}
